import { render, staticRenderFns } from "./CampaignAdditionalFields.vue?vue&type=template&id=49c7a2b8&"
import script from "./CampaignAdditionalFields.vue?vue&type=script&lang=js&"
export * from "./CampaignAdditionalFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports